
import { GetOS, GetBrowser } from "@/utils/JSTool";

export const FromGameSakaApp =
  navigator &&
  navigator.userAgent &&
  (navigator.userAgent.indexOf("GameSakaApp") > -1 || navigator.userAgent.indexOf("SKGames") > -1 || navigator.userAgent.indexOf("AndroidApp") > -1) || !!localStorage.getItem("fromApp");
export const FromStandAlone = (navigator && navigator.standalone) || matchMedia("(display-mode: standalone)").matches;
export const FromIPhone = GetOS() == "iOS" && GetBrowser() == "Safari";
export const FromInstalled = FromStandAlone || FromGameSakaApp;